import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ServerIncidentsIncident } from 'projects/login/src/app/services/server-status/models/server-incidents-incident';
import { environment } from 'projects/login/src/environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ServerStatusService {
  private _http = inject(HttpClient);

  statusPageId = environment.statusPageId;

  public getIncidents(): Observable<ServerIncidentsIncident[]> {
    return this._http.get<ServerIncidentsIncident[]>(`/api/v2/status/${this.statusPageId}/incidents`);
  }
}
